/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import { useLayoutEffect } from 'react';
import React from 'react';
import ReactMarkdown from 'react-markdown/with-html';
import { connect } from 'react-redux';

/* eslint-disable import/no-cycle */
import ChosenSchoolDetailsDisplay from '../../components/ChosenSchoolDetailsDisplay';
import PageLayout from '../../components/PageLayout/PageLayout';
import analytics from '../../lib/analytics';
import {
  eligibilityReasonSelector,
  periodSelector,
  selectedCourseSelector,
  selectedSchoolSelector,
} from '../../reducers/selectors';

export const somethingWentWrong = {
  title: 'Sorry, looks like something went wrong.',
  body:
    'You probably were not meant to see this! Please get in touch with us if this problem continues.',
};

export const IneligiblePage = ({ reason, chosenSchool, chosenCourse, chosenPeriod }) => {
  const { schoolName, universityName } = chosenSchool;
  const { label: courseName } = chosenCourse;
  const { startDate: periodStartDate, endDate: periodEndDate } = chosenPeriod;

  useLayoutEffect(() => {
    analytics.sendEvent('View - Page', 'ineligible');
  }, []);
  const { REACT_APP_PLATFORM_DASHBOARD: PLATFORM_DASHBOARD_URL } = process.env;

  return (
    <PageLayout title={reason.title} socialProofText={['ineligible']}>
      <div className="">
        <ChosenSchoolDetailsDisplay
          schoolName={schoolName}
          universityName={universityName}
          courseName={courseName}
          periodStartDate={periodStartDate}
          periodEndDate={periodEndDate}
        />
      </div>
      <div className="mt-4">
        <ReactMarkdown
          className="flex flex-col gap-8"
          source={reason.body}
          linkTarget="_blank"
          escapeHtml={false}
        />
      </div>

      <div className="mt-12">
        <a href={`${PLATFORM_DASHBOARD_URL}`} className="button niso-button close-button">
          Close
        </a>
      </div>
    </PageLayout>
  );
};

IneligiblePage.propTypes = {
  reason: PropTypes.shape({
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
  }).isRequired,
  chosenSchool: PropTypes.shape({
    schoolName: PropTypes.string,
    universityName: PropTypes.string,
  }),
  chosenCourse: PropTypes.shape({
    label: PropTypes.string,
  }),
  chosenPeriod: PropTypes.shape({
    startDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    endDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
};

export const mapStateToProps = state => ({
  reason: eligibilityReasonSelector(state),
  chosenSchool: selectedSchoolSelector(state),
  chosenCourse: selectedCourseSelector(state),
  chosenPeriod: periodSelector(state),
});

export default connect(mapStateToProps, null)(IneligiblePage);
